export default {"src":"/_next/static/media/default-profile.e1b5283e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};